import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22metadata.ts%22,%22import%22:%22Roboto_Mono%22,%22arguments%22:[{%22variable%22:%22--font-roboto-mono%22,%22adjustFontFallback%22:true,%22display%22:%22swap%22,%22style%22:%22normal%22,%22subsets%22:[%22latin%22]}],%22variableName%22:%22robotoMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Roboto Mono', 'Roboto Mono Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
